<template>
    <div id="businessList" class="app-inner">
        <div class="public-btn-div flex align-cen">
      <div class="public-add"  @click="addBus">
        新增分类
      </div>
           <div class="businessList_header flex align-cen mft">
            <el-input
            placeholder="请输入分类名称"
            v-model="searchname"
            clearable
            >
            <i slot="prefix" class="el-input__icon el-icon-search" @click="search"></i>
        </el-input>
         <div class="businessList-filter-list flex align-cen public-btn-small" style="padding-left:0">
            <div class="public-btn-small-primary" @click="search">
          搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
     </div>
    </div>
     <div class="businessList-container">
        <div class="businessList-container-table">
             <el-table
            :data="itemList"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column
            prop="name"
            label="分类"
           align="center"
             >
             <template slot-scope="scope" >
               <div v-if="scope.row.sort == 0">
                    <p style="color:#000">{{scope.row.name}}</p>
                    <p style="font-size:13px"> {{scope.row.remark}}</p>
               </div>
                <div v-else style="color:#000">
                {{scope.row.name}}
               </div>
              </template>
            </el-table-column>
            <el-table-column
            prop="sort"
            label="排序"
           align="center"
            >
            </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            >
              <template slot-scope="scope">
                <div  v-if="scope.row.sort != 0">
                    <el-button type="text" size="small" @click.stop="editPro(scope.row)">编辑</el-button>
                <el-button type="text" size="small" @click.stop="deletPro(scope.row)" class="daner">删除</el-button>
                </div>
                <div v-else>
                  <el-button type="text" size="small" >禁止操作</el-button>  
                </div>
              </template>
            </el-table-column>
        </el-table>
         <el-pagination
            class="jiange"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
     </div>
     <!-- 增加修改弹窗 -->
      <el-dialog
  :title="tit"
  :visible.sync="centerDialogVisible"
  width="30%"
  :append-to-body="true"
  center>
   <div class="forminfo"
    v-loading="loading"
      element-loading-text="正在添加中..."
     element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
   >
    <el-form :model="formLabelAlign" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
         <el-form-item label="分类名称：" prop="name">
              <el-input v-model="formLabelAlign.name" clearable placeholder="20字以内" class="bbb"></el-input>
        </el-form-item>
         <el-form-item label="排序：">
              <el-input v-model.number="formLabelAlign.sort" clearable class="bbb" minlength="0" maxlength="5"></el-input>
        </el-form-item>
    </el-form>
     <div class="btn" @click="onsubmit('ruleForm')">确定</div>
   </div>
</el-dialog>
    </div>
</template>
<script>
import {getbusinessInfo} from "@/api/index/index"  //企业分类
import {getbusinessedit} from "@/api/index/index"  //企业分类新增修改接口
import { deletList } from "@/api/index/index"   //删除项目
import debounce from '../../utils/debounce.js' //防抖
import { stringify } from 'qs'
export default {
	name: "businessList",
	 data: () => {
    return {
        loading:false,
        edittype:0,
        tit:'',
        centerDialogVisible:false,
        totalNum:0,
        currentPage: 1, //初始页
        PageSize: 20, //每页的数据
        totalCount: 0,
        pageSizes:[20,30,40,50,100],
        newArry:[],
        searchname:'',
        itemList:[],
        formLabelAlign:{
            name:'',
            sort:'',
            id:''
        },
        rules: {
             name: [
             { required: true, message: '请正确填写分类名称', trigger: 'blur' },
             { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
          ],
        }
	}
	},
	mounted(){
	},
  activated(){
  this.gethisInfo()
},
    created(){
        // this.gethisInfo()
    },
	methods: {
        // 搜索
        search(){
        this.currentPage=1
        this.gethisInfo()
        },
        // 重置
        reset(){
            this.searchname = ""
            this.currentPage = 1
            this.gethisInfo()
        },
        // 删除项目
         deletPro(data){
          this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            deletList({
              id:data.id,
              },'delete')
                .then(res => {
                  this.$message.success('已删除');
                   this.gethisInfo()
              })
              .catch(err => {
              })
        })
      },
        // 确定
        onsubmit(formName){
            this.$refs[formName].validate((valid) => {
                if(valid){
                  if(typeof(this.formLabelAlign.sort) == 'string' && this.formLabelAlign.sort != "") return this.$message.error('排序只能输入数字')
                      //防抖提交
                            debounce(() => {
                             this.comHttps()
                         }, 500)
                }
            })
        },
        comHttps(){
          this.loading = true
          if(this.edittype == 0){
                        getbusinessedit(
                            {
                                name:this.formLabelAlign.name,
                                sort:this.formLabelAlign.sort
                            },
                            'post')
                        .then(res => {
                           this.loading = false
                          if(res.code == 1){
                            this.$message.error(res.msg);
                          }else{
                                this.$message.success('添加成功'); 
                           this.gethisInfo()
                           setTimeout(() => {
                      this.centerDialogVisible = false
                    }, 100);
                          }
                        })
                        .catch(err => {
                          this.loading = false
                        })
                    }else{
                            getbusinessedit(
                            {
                                name:this.formLabelAlign.name,
                                sort:this.formLabelAlign.sort,
                                id:this.formLabelAlign.id
                            },
                            'put')
                        .then(res => {
                          this.loading = false
                          if(res.code == 1){
                              this.$message.error(res.msg);
                          }else{
        this.$message.success('修改成功'); 
                           this.gethisInfo()
                           setTimeout(() => {
                      this.centerDialogVisible = false
                       }, 100);
                          }
                        })
                        .catch(err => {
                          this.loading = false
                        })
                    }
        },
        // 新增分类
        addBus(){
           this.edittype = 0  //0表示新增项目，1表示修改项目
           this.tit = "新增企业分类"
           this.centerDialogVisible = true 
           this.formLabelAlign = {
            name:'',
            sort:'',
           }
           if(this.$refs['ruleForm']){
           this.$refs['ruleForm'].clearValidate();
         }
        },
        // 修改分类
        editPro(data){
            this.edittype = 1  //0表示新增项目，1表示修改项目
           this.tit = "修改企业分类"
           this.centerDialogVisible = true 
           this.formLabelAlign = {
            name:data.name,
            sort:data.sort,
            id:data.id
           }
               if(this.$refs['ruleForm']){
           this.$refs['ruleForm'].clearValidate();
         }
        },
        // 获取分类
        gethisInfo(){
            getbusinessInfo({
                name:this.searchname,
                current: this.currentPage,
                size:this.PageSize,
            })
            .then(res => {
              this.itemList = res.data.records
              this.totalCount = res.data.total;
            })
            .catch(err => {
            })
        },
            handleSizeChange(val) {
       this.PageSize = val
       this.gethisInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.gethisInfo()
    },
       //前端自己分页
            getResultsData() {
                // this指向改一下
                let that = this;
                let list = that.itemList; //后端回来表格的数据
                //渲染的数据newArry赋值
                this.newArry= list.filter(
                (item, index) =>
                    index < that.currentPage * that.PageSize &&
                    index >= that.PageSize * (that.currentPage - 1)
                ); //根据页数显示相应的内容
     },
	}
}
</script>
<style lang="scss" scoped>
#businessList{
    padding: 0 20px;
.businessList_header{
    .el-input{
        width: 200px;
        margin-right: 16px;
        height: 30px;
    }
}
.businessList-container{
    padding: 20px 0;
    .businessList-container-title{
        text-align: right;
        font-size: 18px;
        color: #409eff;
        cursor: pointer;
    }
    .businessList-container-table{
        margin-top: 20px;
    }
    .jiange{
        margin-top: 20px;
    }
}
}
.forminfo{
     .btn{
    width: 80%;
    height: 50px;
    background-color: #409eff;
    border-radius: 0.1vh;
    border: none;
    color: #fff;
    margin: 20px auto;
    margin-bottom: 0;;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
     }
}
::v-deep{
             .el-input__inner{
            height: 30px !important;
            line-height: 30px !important;
        }
        .el-input__icon{
            line-height: 30px;
        }
}
</style>